function resizeYoutubePlayer(element) {
    var width = element.offsetWidth;
    var height = width * 0.55;
    element.height = height;
}